// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import WantedLists from './WantedLists';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(WantedLists);
